export const color = {
  red: "#F2552C",
  yellow: "#F6D155",
  blue: "#96DFE4",
  green: "#88B04B",
  white: "#FFFFFF",
  black: "#000000",
  darkyellow: "#F3D5AD",
  purple: "#b37feb",
};
export const cards = [
  { name: "스킨십", color: color.red, distance: 1 },
  { name: "사랑", color: color.red, distance: 1 },
  { name: "이상형", color: color.red, distance: 1 },
  { name: "매력", color: color.red, distance: 2 },
  { name: "친구", color: color.red, distance: 2 },
  { name: "결혼", color: color.red, distance: 2 },
  { name: "외모", color: color.red, distance: 2 },
  { name: "선물", color: color.red, distance: 3 },
  { name: "칭찬", color: color.red, distance: 3 },
  { name: "외로움", color: color.red, distance: 3 },
  { name: "고민", color: color.yellow, distance: 1 },
  { name: "상처", color: color.yellow, distance: 1 },
  { name: "사춘기", color: color.yellow, distance: 1 },
  { name: "별명", color: color.yellow, distance: 2 },
  { name: "최고의 순간", color: color.yellow, distance: 2 },
  { name: "자랑", color: color.yellow, distance: 2 },
  { name: "굴욕/실패", color: color.yellow, distance: 2 },
  { name: "콤플렉스", color: color.yellow, distance: 3 },
  { name: "소원", color: color.yellow, distance: 3 },
  { name: "꿈", color: color.yellow, distance: 3 },
  { name: "형제/자매", color: color.green, distance: 1 },
  { name: "엄마/아빠", color: color.green, distance: 1 },
  { name: "장례식", color: color.green, distance: 1 },
  { name: "공동체", color: color.green, distance: 2 },
  { name: "갈등", color: color.green, distance: 2 },
  { name: "리더쉽", color: color.green, distance: 2 },
  { name: "어린이", color: color.green, distance: 2 },
  { name: "학교", color: color.green, distance: 3 },
  { name: "멘토", color: color.green, distance: 3 },
  { name: "감사", color: color.green, distance: 3 },
  { name: "종교", color: color.blue, distance: 1 },
  { name: "직장", color: color.blue, distance: 1 },
  { name: "돈", color: color.blue, distance: 1 },
  { name: "여행", color: color.blue, distance: 2 },
  { name: "운동", color: color.blue, distance: 2 },
  { name: "공부", color: color.blue, distance: 2 },
  { name: "시간", color: color.blue, distance: 2 },
  { name: "영화", color: color.blue, distance: 3 },
  { name: "음악", color: color.blue, distance: 3 },
  { name: "음식", color: color.blue, distance: 3 },
  { name: "", color: color.white },
  { name: "방향전환", color: color.black, fontColor: color.darkyellow },
  { name: "빅3", color: color.black, fontColor: color.red },
  { name: "점프", color: color.black, fontColor: color.darkyellow },
  { name: "반사", color: color.black, fontColor: color.blue },
  { name: "재활용", color: color.black, fontColor: color.green },
  {
    name: "색바꾸기",
    color: color.black,
    fontColor: [color.darkyellow, color.blue, color.red, color.green],
  },
  { name: "", color: color.white },
  { name: "방향전환", color: color.black, fontColor: color.darkyellow },
  { name: "빅3", color: color.black, fontColor: color.red },
  { name: "점프", color: color.black, fontColor: color.darkyellow },
  { name: "반사", color: color.black, fontColor: color.blue },
  { name: "재활용", color: color.black, fontColor: color.green },
  {
    name: "색바꾸기",
    color: color.black,
    fontColor: [color.darkyellow, color.blue, color.red, color.green],
  },
];

export const hardcards = [
  { name: "원한", color: color.purple, distance: 1 },
  { name: "범죄", color: color.purple, distance: 1 },
  { name: "질투", color: color.purple, distance: 2 },
  { name: "혐오", color: color.purple, distance: 2 },
  { name: "미필적 고의", color: color.purple, distance: 3 },
  { name: "뒷담화", color: color.purple, distance: 3 },
  { name: "배신", color: color.purple, distance: 1 },
  { name: "독설", color: color.purple, distance: 1 },
  { name: "자만", color: color.purple, distance: 2 },
  { name: "성", color: color.purple, distance: 2 },
  { name: "고뇌", color: color.purple, distance: 3 },
  { name: "강제", color: color.purple, distance: 3 },
  { name: "알코올", color: color.purple, distance: 1 },
  { name: "수줍음", color: color.purple, distance: 1 },
  { name: "새벽", color: color.purple, distance: 2 },
];
